export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_SUCCEEDED = 'GET_EVENTS_SUCCEEDED';
export const GET_EVENTS_FAIL = 'GET_EVENTS_FAIL';
export const RESET_EVENTS = 'RESET_EVENTS';

export const SELECT_EVENT = 'SELECT_EVENT';
